import { TripsNav } from '../TripsNav';

export default function TripIndexPreContent() {
  return (
    <div>
      <TripsNav />
    </div>
  );
}
